<template>
  <div>
    <section class="banners">
      <div class="carousel swiper-container">
        <div class="carousel-body swiper-wrapper">
          <div class="swiper-slide carousel-box">
            <img src="../assets/img/flow/gamebanner3.png" />
          </div>
          <div class="swiper-slide carousel-box">
            <img src="../assets/img/flow/gamebanner1.png" />
          </div>
          <div class="swiper-slide carousel-box">
            <img src="../assets/img/flow/gamebanner2.png" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </section>
    <div class="fixed-div">
      <div class="main-div" @mouseover="showSt = true">
        <img
          src="../assets/img/flow/fixed/float.png"
          alt=""
          @mouseout="showSt = false"
        />
      </div>
      <div
        class="content-wrap"
        :class="showSt ? 'showSt' : ''"
        @mouseover="showSt = true"
        @mouseout="showSt = false"
      >
        <div class="par-wrap" @click="toContact">
          <img src="../assets/img/flow/fixed/phone_icon.png" alt="" />
          <div class="par-desc">
            <h4>游戏商务合作</h4>
            <p>联系邮件：</p>
            <p>game@chinanola.com</p>
            <p>或留下信息我们联系您</p>
          </div>
        </div>
        <div class="weixin-wrap">
          <img
            src="../assets/img/flow/fixed/weixin.png"
            class="weixin"
            alt=""
          />
          <div class="img-wrap">
            <img src="../assets/img/g-wchat.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <!-- 轻游戏 -->
      <section class="sgames">
        <div class="h4-wrap">
          <div class="colorDiv1"></div>
          <div class="colorDiv2"></div>
          <div class="colorDiv3"></div>
          <div class="colorDiv4"></div>
          <div class="colorDiv5"></div>
          <h4>小游戏</h4>
        </div>
        <p style="margin-bottom: 0">Games</p>

        <div class="item">
          <div v-for="(game, index) in sgames" :key="index" class="box">
            <div v-if="index < 3 || showMore">
              <div class="surface">
                <img :src="game.imgurl" :alt="game.name" />
              </div>
              <div class="mask-div">
                <div class="logo-div">
                  <img :src="game.icon" alt="" />
                </div>
                <div class="title-div">
                  <h6>{{ game.name }}</h6>
                  <p>{{ game.type }}</p>
                </div>
                <div class="icon-div">
                  <img src="../assets/img/flow/icon_link.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="more" v-show="!showMore" @click="showMore = true">
          查看更多
        </div>
      </section>
      <!-- 手游 -->
      <section class="mgames">
        <div class="h4-wrap">
          <!-- <div class="colorDiv1" style="left: 31%; width: 25%"></div>
          <div class="colorDiv2" style="left: 32%"></div>
          <div class="colorDiv3" style="left: 58%"></div>
          <div class="colorDiv4" style="left: 58%"></div>
          <div class="colorDiv5" style="width: 14%; left: 43%"></div> -->
          <div class="colorDiv1" style="left: 31%; width: 25%"></div>
          <div class="colorDiv2" style="left: 25%"></div>
          <div class="colorDiv3" style="left: 65%"></div>
          <div class="colorDiv4" style="left: 65%"></div>
          <div class="colorDiv5" style="width: 14%; left: 43%"></div>
          <h4>弹幕游戏</h4>
        </div>
        <p>Danmaku game</p>

        <div class="item">
          <div v-for="(game, index) in mgames" :key="index" class="box">
            <div v-if="index < 3 || showMore">
              <div class="surface" style="height: auto !important">
                <img :src="game.imgurl" :alt="game.name" />
              </div>
              <!-- <div class="mask-div">
                <div class="logo-div">
                  <img :src="game.icon" alt="" />
                </div>
                <div class="title-div">
                  <h6>{{ game.name }}</h6>
                  <p>{{ game.type }}</p>
                </div>
                <div class="icon-div">
                  <img src="../assets/img/flow/icon_link.png" alt="" />
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </section>

      <section class="part-wrap">
        <div class="h4-wrap">
          <div class="colorDiv1" style="left: 31%; width: 25%"></div>
          <div class="colorDiv2" style="left: 25%"></div>
          <div class="colorDiv3" style="left: 65%"></div>
          <div class="colorDiv4" style="left: 65%"></div>
          <div class="colorDiv5" style="width: 14%; left: 43%"></div>
          <h4>合作伙伴</h4>
        </div>
        <p>Cooperative Partner</p>
        <div class="item-wrap">
          <div class="item" v-for="(item, index) in partners" :key="index">
            <img :src="item.icon" alt="" srcset="" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      partners: [
        {
          icon: require("../assets/img/flow/par_game/par1.png"),
          nickname: "18183媒体",
        },
        {
          icon: require("../assets/img/flow/par_game/par2.png"),
          nickname: "17173媒体",
        },
        {
          icon: require("../assets/img/flow/par_game/par3.png"),
          nickname: "今日游戏",
        },
        {
          icon: require("../assets/img/flow/par_game/par4.png"),
          nickname: "发行人计划",
        },
        {
          icon: require("../assets/img/flow/par_game/par5.png"),
          nickname: "抖音小游戏",
        },
        {
          icon: require("../assets/img/flow/par_game/par6.png"),
          nickname: "快手小游戏",
        },
        {
          icon: require("../assets/img/flow/par_game/par7.png"),
          nickname: "摸摸鱼",
        },
        {
          icon: require("../assets/img/flow/par_game/par8.png"),
          nickname: "君海游戏",
        },
        {
          icon: require("../assets/img/flow/par_game/par9.png"),
          nickname: "银汉游戏",
        },
        {
          icon: require("../assets/img/flow/par_game/par10.png"),
          nickname: "艾奥互娱",
        },
        {
          icon: require("../assets/img/flow/par_game/par11.png"),
          nickname: "千月网络",
        },
        {
          icon: require("../assets/img/flow/par_game/par12.png"),
          nickname: "畅玩文化",
        },
        {
          icon: require("../assets/img/flow/par_game/par13.png"),
          nickname: "朝夕光年",
        },
        {
          icon: require("../assets/img/flow/par_game/par14.png"),
          nickname: "oppo游戏",
        },
      ],
      sgames: [
        {
          imgurl: require("../assets/img/flow/icon_game_1.png"),
          name: "波波球",
          icon: require("../assets/img/flow/icon_1.png"),
          type: "休闲射击类",
        },
        {
          imgurl: require("../assets/img/flow/icon_game_2.png"),
          name: "我这一刀下去",
          icon: require("../assets/img/flow/icon_2.png"),
          type: "竞技类",
        },
        {
          imgurl: require("../assets/img/flow/icon_game_3.png"),
          name: "经典90坦克",
          icon: require("../assets/img/flow/icon_3.png"),
          type: "射击类",
        },
        {
          imgurl: require("../assets/img/flow/icon_game_4.png"),
          name: "极速大乱斗",
          icon: require("../assets/img/flow/icon_4.png"),
          type: "MOBA",
        },
        {
          imgurl: require("../assets/img/flow/icon_game_5.png"),
          name: "papa嘭",
          icon: require("../assets/img/flow/icon_5.png"),
          type: "音乐类",
        },
        {
          imgurl: require("../assets/img/flow/icon_game_6.png"),
          name: "张全蛋工厂",
          icon: require("../assets/img/flow/icon_6.png"),
          type: "经营类",
        },
        {
          imgurl: require("../assets/img/flow/icon_game_7.png"),
          name: "球球作战大冒险",
          icon: require("../assets/img/flow/icon_7.png"),
          type: "休闲类",
        },
        {
          imgurl: require("../assets/img/flow/icon_game_8.png"),
          name: "爱再24H",
          icon: require("../assets/img/flow/icon_8.png"),
          type: "AVG",
        },
        {
          imgurl: require("../assets/img/flow/icon_game_9.png"),
          name: "水上冲冲冲",
          icon: require("../assets/img/flow/icon_9.png"),
          type: "休闲类",
        },
        {
          imgurl: require("../assets/img/flow/icon_game_10.png"),
          name: "小鸡爱冒险",
          icon: require("../assets/img/flow/icon_10.png"),
          type: "休闲类",
        },
        {
          imgurl: require("../assets/img/flow/icon_game_11.png"),
          name: "天天对对碰",
          icon: require("../assets/img/flow/icon_11.png"),
          type: "休闲类",
        },
      ],
      mgames: [
        // {
        //   imgurl: require("../assets/img/flow/icon_game_12.png"),
        //   name: "天空之战",
        //   icon: require("../assets/img/flow/icon_12.png"),
        //   type: "休闲类",
        // },
        {
          imgurl: require("../assets/img/flow/icon_game_13.png"),
          name: "弹幕游戏",
          icon: require("../assets/img/flow/icon_12.png"),
          type: "休闲类",
        },
      ],
      pages: "4",
      bannerArr: null,
      showMore: false,
      showSt: false,
    };
  },
  created() {
    // this.$ajax.post("/banners/" + this.pages).then(function(res) {
    //   this.carousel = res.data.banners;
    // }).catch(error => {
    //   console.log(error);
    // })
    // this.$ajax.get("/getGame").then(function(res){
    //   vm.sgames = res.data.games[0];
    //   vm.mgames = res.data.games[1];
    // }).catch(error => {
    //   console.log(error);
    // })
  },
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      pagination: ".swiper-pagination",
      paginationClickable: ".swiper-pagination",
      autoplay: 3000,
      spaceBetween: 0,
    });
  },
  methods: {
    toContact() {
      this.$router.push("/contact");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/global";
@import "../assets/css/function";
@import "../assets/css/index";
@import "../assets/css/fixed";

.colorDiv1 {
  position: absolute;
  width: 27%;
  left: 28%;
  height: 5px;
  background: #e9c9fd;
}
.colorDiv2 {
  position: absolute;
  width: 8%;
  left: 28%;
  top: 41%;
  height: 5px;
  background: #f8d49a;
}
.colorDiv3 {
  position: absolute;
  width: 5%;
  left: 63%;
  top: 23%;
  height: 7px;
  background: #f6c1d1;
}
.colorDiv4 {
  position: absolute;
  width: 9%;
  left: 63%;
  top: 51%;
  height: 2px;
  background: #c5e8c5;
}
.colorDiv5 {
  position: absolute;
  width: 8%;
  left: 46%;
  top: 77%;
  height: 6px;
  background: #a2d0fd;
}
// 轻游戏，手游

.sgames,
.mgames,
.part-wrap {
  margin-bottom: 4rem;
  .h4-wrap {
    position: relative;

    h4 {
      letter-spacing: 4px;
      color: #535353;
      line-height: 3rem;
      font-weight: 700;
      text-align: center;
    }
  }
  > p {
    letter-spacing: 1px;
    font-weight: 700;
    line-height: 1.6em;
    color: #535353;
    text-align: center;
  }
}

.mask-div {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70px;
  z-index: 666;
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.3) 50%,
    rgba(0, 0, 0, 0) 100%
  );
  // background: rgba($color: #000000, $alpha: .3);
  border-radius: 0 0 1rem 1rem;
  display: flex;
  justify-content: space-around;
  .logo-div {
    margin: 0 auto;
    overflow: hidden;
    img {
      width: 50px;
      height: 50px;
      border-radius: 0.5rem;
    }
  }
  .title-div {
    width: 58%;
    h6,
    p {
      color: #fff;
      line-height: 1.5rem;
    }
    h6 {
      font-size: 1rem;
    }
  }
  .icon-div {
    width: 20%;
    > img {
      width: 40px;
      height: 40px;
      margin-top: 0.5rem;
    }
  }
}

.sgames,
.mgames {
  > p {
    // margin-bottom: 0 !important;
  }
  .more-wrap {
    position: relative;
    height: 50px;
    span {
      position: absolute;
      right: 10px;
      display: block;
      padding: 15px 10px;
      font-size: 0.8rem;
      cursor: pointer;
      &:hover {
        color: rgb(178, 16, 16);
      }
    }
  }
  .item {
    margin: 2rem 0 0 0;
    z-index: 66;
    position: relative;
    .box {
      position: relative;

      margin-top: 2rem;
      margin-right: 1%;
      &:nth-last-child(1),
      &:nth-last-child(2),
      &:nth-last-child(3),
      &:nth-last-child(4) {
        margin-bottom: 0;
      }
      .surface {
        height: 200px;
        img {
          height: 100%;
          border-radius: 1rem;
          object-fit: cover;
        }
      }
      .props {
        font-family: "helvetica";
        position: relative;
        padding: 10px 0;
        h6 {
          font-size: 1rem;
          line-height: 2.5em;
          color: #535353;
          font-weight: 400;
        }
        p {
          line-height: 1.5em;
          color: #535353;
        }
        i {
          position: absolute;
          right: 0;
          bottom: 10px;
          font-size: px2rem(32);
          color: #e4e4e4;
          cursor: pointer;
          &:hover {
            & + img {
              visibility: visible;
              display: block;
              opacity: 1;
            }
          }
        }
        .mask {
          visibility: hidden;
          position: absolute;
          top: 90%;
          z-index: 3;
          opacity: 0;
          width: 100%;
          height: 300px;
          background-color: #fff;
          transition: opacity 0.3s;
          border-radius: 20px;
        }
      }
    }
  }
}
.more {
  position: relative;
  bottom: 0;
  padding: 1rem 0;
  text-align: center;
  color: #999;
}

.part-wrap {
  .h4-wrap {
    position: relative;
  }
  .item-wrap {
    margin: 2rem 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    z-index: 666;
    .item {
      width: 20%;
      padding: 0.5rem;
      > P {
        color: #535353;
        text-align: center;
        line-height: 30px;
        font-size: 1.4rem;
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/games.vue